import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { setLayerMetadata } from '../../layerMetadata'
import { findFeature } from '../../findFeature'

import { findPlaceMarker } from './findPlaceMarker'
import { updatePlaceFeature } from './updatePlaceFeature'

const nonblockingRender = createNonBlockingRenderByTime()

export const changelogUpdatePlaceFeatures = async (
  layer: VectorLayer<VectorSource>,
  markers: Record<string, uui.domain.ui.map.markers.Place>,
  mapStyles: uui.domain.ui.map.markers.MapStyles['place'],
  selection: Set<string>,
  markerIds: IterableIterator<string>,
) => {
  nonblockingRender.reset()

  for (const markerId of markerIds) {
    await nonblockingRender.next()

    const marker = findPlaceMarker(markers, markerId)
    if (!marker) {
      throw new Error(
        `Trying to update Place feature with lat-lng: ${markerId} but no marker exist on the map`,
      )
    }

    const feature = findFeature(layer, marker.id)

    if (!feature) {
      throw new Error(
        `Trying to update Place feature with lat-lng: ${marker.id} but no feature exist on the map`,
      )
    }

    const selected = selection.has(markerId)
    updatePlaceFeature(mapStyles, marker, feature, selected)
  }

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
